<template>
  <div class="title-with-subclass">
    <div class="title-with-subclass_title">
      {{ title }}
    </div>
    <div class="title-with-subclass_title">
      {{ subtitle }}
    </div>
    <ContentChipsList :chips="subclasses" />
  </div>
</template>
<script>
export default {
  name: "TitleWithSubclass",
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    subclasses: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/title-with-subclass";
</style>